import { render, staticRenderFns } from "./ServiceCalendarPage.vue?vue&type=template&id=5f1882e2&"
import script from "./ServiceCalendarPage.vue?vue&type=script&lang=js&"
export * from "./ServiceCalendarPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports